import { Message } from 'antd';
import { List } from 'immutable';
import { getHomeworkList, getHomeworkDetails, submitHomework } from '../../api/index.js';

let getHomework = async (data, dispatch) => {
  let res = await getHomeworkList(data)
  if (res.code === 200) {
    if (res.output && res.output.length < 10) {
      dispatch({type: 'SET_HOMEWORKLIST', payload: {
        level: data.level,
        homeworkList: res.output,
        scrollFlag: false
      }});
      return
    } else if (res.output && res.output.length >= 10) {
      dispatch({type: 'SET_HOMEWORKLIST', payload: {
        level: data.level,
        homeworkList: res.output,
        scrollFlag: true
      }});
    } else {
      dispatch({type: 'SET_HOMEWORKLIST', payload: {
        level: data.level,
        homeworkList: List([]),
        scrollFlag: true
      }});
    }
    return;
  }
  Message.error(res.tip);
}

let conCatHomework = async(data, dispatch) => {
  let res = await getHomeworkList(data)
  if (res.code === 200) {
    if (res.output && res.output.length < 10) {
      dispatch({type: 'CONCAT_HOMEWORKLIST', payload: {
        level: data.level,
        homeworkList: res.output,
        scrollFlag: false
      }});
      return
    } else if (res.output && res.output.length >= 10) {
      dispatch({type: 'CONCAT_HOMEWORKLIST', payload: {
        level: data.level,
        homeworkList: res.output,
        scrollFlag: true
      }});
    }
    return;
  }
  Message.error(res.tip);
}

export function fetchHomeworkList(data) {
  return (dispatch) => {
    getHomework(data, dispatch);
  }
}

export function catHomeworkList(data) {
  return (dispatch) => {
    conCatHomework(data, dispatch);
  }
}

export function fetchHomeworkDetails(data) {
  return async (dispatch) => {
    let res = await getHomeworkDetails(data)
    if (res.code === 200) {
      dispatch({type: 'SET_HOMEWORKDETAILS', payload: {
        homeworkDetails: res.output,
        homework: res.output.detail ? res.output.detail.student_file : ''
      }});
      return;
    }
    Message.error(res.tip);
  }
}

export function updateHomework(data) {
  return async (dispatch) => {
    let res = await submitHomework({
      homework_id: parseInt(data.id, 10),
      student_file: data.path
    });
    if (res.code === 200) {
      Message.success('作业上传成功');
    } else {
      Message.error(res.tip);
    }
    dispatch({type: 'SET_HOMEWORK', payload: {
      homework: data.url.replace(/!m/g, '!b')
    }});
  }
}

export function emptyHomeworkDetails() {
  return (dispatch) => {
    dispatch({type: 'EMPTY_HOMEWORK'});
  }
}
    


// WEBPACK FOOTER //
// ./src/store/actions/homework.js